export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10896.ca1ce93e.jpg";